import StatusBadge from "../../../../../components/common/StatusBadge/StatusBadge";
import TruncateTooltip from "../../../../../components/common/TruncateTooltip/TruncateTooltip";
import type { ChannelCatalogItem, StandaloneCard } from "../../../api/connectionHub.types";
import { CONNECTION_STATUS_PRESENTATION, isFailedStatus } from "../../../constants/connectionStatus.constants";
import ConnectionLogo from "../../common/ConnectionLogo/ConnectionLogo";
import ConnectionErrorPanel from "../../common/ConnectionErrorPanel/ConnectionErrorPanel";
import styles from "./StandaloneConnectionCard.module.scss";

export interface StandaloneConnectionCardProps {
  card: StandaloneCard;
  channel?: ChannelCatalogItem;
  error?: string | null;
}

const StandaloneConnectionCard = ({ card, channel, error }: StandaloneConnectionCardProps): JSX.Element => {
  const status = CONNECTION_STATUS_PRESENTATION[card.status];
  const failed = isFailedStatus(card.status);

  return (
    <article className={styles.card}>
      <div className={styles.identity}>
        <ConnectionLogo logoUrl={channel?.logo} className={styles.logo} />
        <div className={styles.text}>
          <TruncateTooltip text={card.connection.ipName} className={styles.name} />
          {card.connection.loginEmail ? <TruncateTooltip text={card.connection.loginEmail} className={styles.email} /> : null}
        </div>
      </div>
      <StatusBadge label={status.label} variant={status.variant} spinner={status.spinner} />
      {failed ? (
        <div className={styles.failure}>
          <ConnectionErrorPanel
            error={error ?? card.lastError ?? `${status.label} for ${card.connection.ipName}.`}
            className={styles.errorPanel}
          />
        </div>
      ) : null}
    </article>
  );
};

export default StandaloneConnectionCard;
